export const MARKDOWN_AI_REQUEST_EVENT = 'learnitive:markdown-ai-request';

export type MarkdownAiRequestDetail = {
  text?: string;
  source: 'slash-menu' | 'selection-toolbar' | 'shortcut';
};

export function dispatchMarkdownAiRequest(
  target: EventTarget,
  detail: MarkdownAiRequestDetail,
): void {
  target.dispatchEvent(new CustomEvent<MarkdownAiRequestDetail>(MARKDOWN_AI_REQUEST_EVENT, {
    bubbles: true,
    detail,
  }));
}
